import { isAxiosError } from 'axios';
import { apiClient } from './apiClient';
import { PublicTherapist, TherapistForService } from '../types/booking.types';

export const therapistsApi = {
  /**
   * Get all public therapists for browsing
   */
  async getAll(): Promise<PublicTherapist[]> {
    const response = await apiClient.get<{
      success: boolean;
      data: { therapists: PublicTherapist[]; total: number };
    }>('/api/public/therapists');

    return response.data.data.therapists;
  },

  /**
   * Get therapists available for a specific service
   * Returns public therapist info (no email) for booking flow
   */
  async getByService(serviceId: string): Promise<TherapistForService[]> {
    const response = await apiClient.get<{
      success: boolean;
      data: { therapists: TherapistForService[]; total: number };
    }>(`/api/services/${serviceId}/therapists`);

    return response.data.data.therapists;
  },

  /**
   * Get a single therapist by ID
   * Returns public therapist info
   */
  async getById(therapistId: string): Promise<PublicTherapist | null> {
    try {
      const response = await apiClient.get<{
        success: boolean;
        data: PublicTherapist;
      }>(`/api/public/therapists/${therapistId}`);

      return response.data.data;
    } catch (error) {
      if (isAxiosError(error) && error.response?.status === 404) {
        return null;
      }
      return null;
    }
  },
};
